<tt-page>
    <tt-card class="col-xs-12 sp-0">
        <tt-input-number ttLabel="number" [(ttModel)]="number" ttDecimals="2" ttTextAlign="right"></tt-input-number>

        <div class="calculator container">
            <div class="row">
                <div class="col-xs-12 text-center">
                    <button type="button" class="btn btn-default calculator__key" (click)="typeNumber('7')">7</button>
                    <button type="button" class="btn btn-default calculator__key" (click)="typeNumber('8')">8</button>
                    <button type="button" class="btn btn-default calculator__key" (click)="typeNumber('9')">9</button>
                </div>

                <div class="col-xs-12 text-center">
                    <button type="button" class="btn btn-default calculator__key" (click)="typeNumber('4')">4</button>
                    <button type="button" class="btn btn-default calculator__key" (click)="typeNumber('5')">5</button>
                    <button type="button" class="btn btn-default calculator__key" (click)="typeNumber('6')">6</button>
                </div>

                <div class="col-xs-12 text-center">
                    <button type="button" class="btn btn-default calculator__key" (click)="typeNumber('1')">1</button>
                    <button type="button" class="btn btn-default calculator__key" (click)="typeNumber('2')">2</button>
                    <button type="button" class="btn btn-default calculator__key" (click)="typeNumber('3')">3</button>
                </div>

                <div class="col-xs-12 text-center">
                    <button type="button" class="btn btn-default calculator__key" (click)="typeNumber('0')">0</button>
                    <button type="button" class="btn btn-default calculator__key" (click)="typeNumber('.')">,</button>
                    <button type="button" class="btn btn-default calculator__key" aria-label="Clear" (click)="deleteNumber()">x</button>
                </div>
            </div>
        </div>

        <tt-button-save ttText="ok" (ttClick)="saveToPrevious()"></tt-button-save>
    </tt-card>
</tt-page>
